<template>
  <div ref="grid-container" class="grid-container-css">
    <LinkWrapper
      v-for="(item, index) in items"
      :key="item.id"
      :link="item.link"
      :width="item.width"
      :height="item.height"
      :show-bottom-bar="showBottomBar"
      @click="clickItem($event, item, shownListing)"
    >
      <Item :item="item" :border-radius="borderRadius" :lazy="index < 10 ? false : true">
        <slot :data="{ ...item, borderRadius }"></slot>
        <slot v-if="showBottomBar" name="bottomBar" :data="{ ...item, borderRadius }"></slot>
      </Item>
    </LinkWrapper>
  </div>
</template>

<script>
import LinkWrapper from './LinkWrapper';
import Item from './Item';
export default {
  components: { LinkWrapper, Item },
  props: {
    items: {
      type: Array,
      required: true
    },
    borderRadius: {
      type: Number,
      required: false,
      default: 4
    },
    showBottomBar: {
      type: Boolean,
      required: false,
      default: false
    },
    sendVectorClick: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      hiddenIds: []
    };
  },
  computed: {
    shownListing() {
      let vm = this;
      return this.items.filter((el) => {
        return !vm.hiddenIds.includes(el.id);
      });
    }
  },
  watch: {
    items() {
      this.loadVectorStats();
    }
  },
  mounted() {
    this.loadVectorStats();
  },
  methods: {
    loadVectorStats() {
      const isMyRequestsPage = this.$route.name.startsWith('profile-my-requests');
      const isProfile = this.$route.name.startsWith('profile');
      if (!isMyRequestsPage && !isProfile) {
        this.$store.dispatch(
          'user/LOAD_VECTORS_STATS',
          this.items.map((result) => result.id)
        );
      }
    },
    clickItem($event, item, shownListing) {
      if (this.sendVectorClick) {
        this.$store.dispatch('vectors/CLICK_VECTOR', { id: item.id });
      }
      if (item.isMaker) {
        const anchor = $event.target.closest('a');
        anchor.setAttribute('target', '_blank');
        this.$dataLayerPush(item.isMockup ? 'stock_mg_content' : 'stock_tm_content');
        return;
      }
      this.$emit('item-click', { item, shownListing }, $event);
    }
  }
};
</script>

<style lang="scss" scoped>
.grid-container-css {
  display: flex;
  flex-wrap: wrap;
  margin-right: -12px;
  margin-top: 5px;
}
.grid-container-css::after {
  --width: 2;
  --height: 1;
  --ratio: calc(var(--width) / var(--height));
  --row-height: 12rem;
  flex-basis: calc(var(--ratio) * var(--row-height));
  content: '';
  flex-grow: 1000000;
}
</style>
